<template>
  <div>
    <div class="select_wrap">
      <div class="scenario_select">
        <div class="select_arrow">
          <select
              @change="selectOne"
              v-model.number="valueSelected"
              class="heigh-45">
            <option v-for="option in value">{{ option }}</option>
          </select>
        </div>
      </div>
    </div>
    <div class="count_head">
      <ul>
        <li v-for="item in valueSelected" class="gain"></li>
        <li v-for="item in (value - valueSelected)"></li>
      </ul>
    </div>
  </div>
</template>

<script>
import {dispatch} from "vuex-pathify";

export default {
  name: "child_dropdown",
  props: {
    value: Number,
    page_no: Number,
  },
  data() {
    return {
      valueSelected: 1,
    }
  },
  methods: {
    selectOne() {
      let moduleName = store.get('moduleName')
      dispatch(moduleName + '/setPostData', {page_no: this.page_no, page_answer: this.valueSelected})
    },
  },
  created() {
    this.selectOne()
  }
}
</script>